import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {
  Wrapper,
  Progress,
} from './style';

import AppState from '../../states/AppState';

class ScrollProgress extends Component {
  position(scrollTop, windowHeight) {
    if (scrollTop < 0) {
      return 'fixed-bottom';
    } else if (scrollTop > windowHeight - (3 * AppState.rem)) {
      return 'fixed-top';
    } else {
      return 'absolute';
    }
  }

  render() {
    const width = AppState.scrollTop / AppState.bodyHeight * 100;
    return (
    <Wrapper
      position={this.position(AppState.scrollTop, AppState.windowHeight)}
    >
      <Progress
        style={{
          width: `${width}%`
        }}
      />
    </Wrapper>
  )
  }
}

export default observer(ScrollProgress);



// WEBPACK FOOTER //
// ./src/components/ScrollProgress/index.js